import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { AffiliateService } from "../../../features/affiliate/services/affiliate.service";

@Component({
  selector: "app-main-layout",
  templateUrl: "./main-layout.component.html",
  styleUrl: "./main-layout.component.scss",
  standalone: false,
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  isPendingCancellation = false;

  constructor(private affiliateService: AffiliateService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.affiliateService.isPendingCancellation$.subscribe((status) => {
        this.isPendingCancellation = status;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
